import { create } from "zustand";
import { serverGET } from "../HttpFunctions";
// using alternate approach right now not using this
const useProjectStore = create((set) => ({
  projectData: null,
  sidemenu: false,
  loading: false,
  setProjectData: (project) => set({ projectData: project }),
  fetchProjectData: async (projectId) => {
    try {
      if (projectId) {
        set({ loading: true });
        const response = await serverGET("/projects/" + projectId);
        set({ projectData: response, loading: false });
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
      set({ loading: false });
    }
  },
  toggleSideMenu: () => set((state) => ({ sidemenu: !state.sidemenu })),
  selectedMenu: "",
  setSelectedMenu: (menu, previous) =>
    set({ selectedMenu: menu, previousMenu: previous }),
  previousMenu: null,
  setPreviousMenu: (menu) => set({ previousMenu: menu }),
}));

export default useProjectStore;
